import React, { useEffect, useState } from 'react'
import { getAllSupplier, getSuppliersWithPage } from "../../services/serviceSupplier";
import { Button, Card, Table } from "antd";
import SupplierActions from "./SupplierActions";
import SupplierCreate from "./SupplierCreate";

const Supplier = () => {

    const [updateList, setListUpdate] = useState(false);
    const [sortedList, setSortedList] = useState([]);
    const [newModal, setNewModal] = useState(false);

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getSuppliers(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getSuppliers = (page, pageSize) => {
        getSuppliersWithPage(page - 1, pageSize)
            .then(({ data }) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const handlers = {
        updater() {
            getSuppliers(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    supplierName: item.name,
                    supplierCode: item.code,
                    supplierDescription: item.description,
                    supplierPhone: item.phone,
                    supplierEmail: item.email,
                    supplierAddress: item.address
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    }


    const columns = [
        {
            title: 'Adı',
            dataIndex: 'supplierName',
            key: 'supplierName'
        },
        {
            title: 'Kodu',
            dataIndex: 'supplierCode',
            key: 'supplierCode'
        },
        {
            title: 'Email',
            dataIndex: 'supplierEmail',
            key: 'supplierEmail'
        },
        {
            title: 'Telefon',
            dataIndex: 'supplierPhone',
            key: 'supplierPhone'
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <SupplierActions record={record} updater={handlers.updater} />
        }
    ]

    return (
        <React.Fragment>
            <Card title={'Tedarikçi Listesi'} extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni Ekle </Button>}>
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ? <SupplierCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater} /> : null}

        </React.Fragment>
    )
}
export default Supplier